// extracted by mini-css-extract-plugin
export default {"chartCustomizationPanel":"chart-customization-panel__wWWdt9dp","section":"section__E67YzNsQ"};